export const SET_AUTH = "SET_AUTH";
export const UNSET_AUTH = "UNSET_AUTH";



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/auth/constants.ts